module.exports = __webpack_public_path__ + "static/media/pc_icon_right_disable.20d78c2a.svg";